import { ComponentPropsWithoutRef } from 'react';
import BackIcon from '../../../assets/logo/BackIcon';
import TextInput from '../../../components-library/inputs/TextInput';
import { useLocationData } from '../provider/LocationDataProvider';
import useTheme from '../../../hooks/ui/useTheme';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import classnames from 'classnames';

const RoomServiceForm = ({ className, ...rest }: ComponentPropsWithoutRef<'div'>) => {
  const deliveryAddressForm = useFormContext();
  const { company, setRoomServiceLocation, setRoomServiceDetails, roomServiceLocationForm } = useLocationData();
  const theme = useTheme();
  const { t } = useTranslation(null, { keyPrefix: 'Modals:OrderMethod:OrderMethodModal' });

  return (
    <>
      <div
        className={classnames('w-full flex flex-row items-center p-xs border rounded-lg appearance-none', className)}
        {...rest}
      >
        <select
          value={roomServiceLocationForm?.roomServiceLocation?.id}
          onChange={(e) => setRoomServiceLocation(e.target.value)}
          className="appearance-none w-full bg-transparent text-sm h-[32px] px-xs"
        >
          {company?.room_service_locations?.map((item) => (
            <option
              key={`room-service-location-${item.id}`}
              value={item.id}
            >{`${item.name} - ${item.street_name} ${item.street_number}`}</option>
          ))}
        </select>
        <BackIcon className="lg:h-3.5 !lg:w-3.5 !md:w-3 md:h-3 !w-2 h-2 -rotate-90" />
      </div>
      {!company?.table_number_hidden && (
        <div className="mt-md">
          <TextInput
            id="room-service-details"
            value={roomServiceLocationForm?.roomServiceDetails}
            placeholder={t(
              `text_inputs.room_service_details.placeholder.${roomServiceLocationForm?.roomServiceLocation?.type}`,
            )}
            onChange={setRoomServiceDetails}
            containerStyle={{
              borderColor: deliveryAddressForm.getFieldState('delivery_street_name').invalid
                ? theme.color.danger
                : undefined,
            }}
            inputContainerStyle="px-md"
            className="placeholder:text-danger"
            autoFocus
          />
        </div>
      )}
    </>
  );
};

export default RoomServiceForm;
